export function formatNepaliNumber(num: any, grouping: boolean = true) {
    if (num === null || num === undefined) return '';

    let numStr = String(num).trim();

    const hasParentheses = numStr.startsWith('(') && numStr.endsWith(')');
    if (hasParentheses) {
        numStr = '-' + numStr.slice(1, -1);
    }

    if (isNaN(Number(numStr))) {
        return numStr;
    }

    const parts = numStr.split('.');
    let integerPart = parts[0];
    const decimalPart = parts.length > 1 ? '.' + parts[1] : '';

    const isNegative = integerPart.startsWith('-');
    if (isNegative) {
        integerPart = integerPart.substring(1);
    }

    let formattedInteger: string;

    if (!grouping) {
        formattedInteger = integerPart;
    } else {
        const length = integerPart.length;
        if (length <= 3) {
            formattedInteger = integerPart;
        } else {
            const lastThreeDigits = integerPart.substring(length - 3);
            const remainingDigits = integerPart.substring(0, length - 3);

            let formattedRemaining = '';
            for (let i = remainingDigits.length; i > 0; i -= 2) {
                const start = Math.max(0, i - 2);
                const twoDigits = remainingDigits.substring(start, i);
                formattedRemaining = (start > 0 ? ',' : '') + twoDigits + formattedRemaining;
            }

            formattedInteger = formattedRemaining + ',' + lastThreeDigits;
        }
    }

    const formatted = (isNegative ? '-' : '') + formattedInteger + decimalPart;

    return hasParentheses ? `(${formatted})` : formatted;
}
